import { render } from "./Chips.vue?vue&type=template&id=5defac5f"
import script from "./Chips.vue?vue&type=script&lang=js"
export * from "./Chips.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__